import { Fragment, type PropsWithChildren, forwardRef } from "react";

import type { TableSkeletonLoaderProps } from "./TableSkeletonLoader.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const TableSkeletonLoader = forwardRef<
  HTMLDivElement,
  PropsWithChildren<TableSkeletonLoaderProps>
>(({ columns, rowCount = 10 }) => {
  const componentArray = Array.from(
    { length: rowCount },
    (_, index) => index + 1,
  );

  return (
    <>
      {componentArray.map((number, index) => (
        <Fragment key={number}>
          {index === 0 && <tr className="h-4" />}
          <tr
            className={cn(
              "bg-neutral-300 relative mx-4 h-16 w-full animate-pulse",
            )}
          >
            <td
              colSpan={columns}
              className="first:rounded-l-lg last:rounded-r-lg"
            />
          </tr>
          <tr className="h-4" />
        </Fragment>
      ))}
    </>
  );
});

TableSkeletonLoader.displayName = "TableSkeletonLoader";

export default TableSkeletonLoader;
